


import { createSlice } from "@reduxjs/toolkit";
import { LoadState } from "../../constants/enum";
import { IWaitList, IWaitListState } from "./waitlistTypes";
import { fetchWaitListAsync, upsertWaitListAsync } from "./waitlistAction";

// Define the initial state
const defaultWaitListState: IWaitListState = {
    waitList: {
        loading: LoadState.idle,
        data: [],
        totalRecords: 0,
        error: null,
    },
    singleWaitList: {
        loading: LoadState.idle,
        data: {} as IWaitList,
        error: null,
    },
};

const waitlistSlice = createSlice({
    name: "waitlist",
    initialState: defaultWaitListState,
    reducers: {
        // Synchronous actions (if needed)
        clearWaitListState: (state) => {
            return defaultWaitListState;
        },
    },
    extraReducers: (builder) => {
        // ############################# Fetch Waitlist ######################################
        builder.addCase(fetchWaitListAsync.pending, (state) => {
            state.waitList.loading = LoadState.pending;
        });
        builder.addCase(fetchWaitListAsync.fulfilled, (state, action) => {
            state.waitList.loading = LoadState.succeeded;
            state.waitList.data = action.payload.data;
            state.waitList.totalRecords = action.payload.recordCount;
            state.waitList.error = null;
        });
        builder.addCase(fetchWaitListAsync.rejected, (state, action) => {
            state.waitList.loading = LoadState.failed;
            state.waitList.error = action.error.message as string;
        });

        // ############################# Upsert Single Waitlist ######################################
        builder.addCase(upsertWaitListAsync.pending, (state) => {
            state.singleWaitList.loading = LoadState.pending;
        });
        builder.addCase(upsertWaitListAsync.fulfilled, (state, action) => {
            state.singleWaitList.loading = LoadState.succeeded;
            state.singleWaitList.data = action.payload;
            state.singleWaitList.error = null;

            // Optionally update the waitList.data if needed
            const index = state.waitList.data.findIndex(
                (item) => item.waitlist_uuid === action.payload.waitlist_uuid
            );
            if (index !== -1) {
                state.waitList.data[index] = action.payload;
            } else {
                state.waitList.data.push(action.payload);
            }
        });
        builder.addCase(upsertWaitListAsync.rejected, (state, action) => {
            state.singleWaitList.loading = LoadState.failed;
            state.singleWaitList.error = action.error.message as string;
        });
    },
});

export const { clearWaitListState } = waitlistSlice.actions;
export const waitlistReducer = waitlistSlice.reducer;